/**
 * CRO Collection Filters
 * Handles filter group collapse/expand, mobile drawer, and in-collection search.
 */
(function () {
  'use strict';

  /* -----------------------------------------------------------------------
     Filter group collapse/expand
     ----------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var title = e.target.closest('.cro-filter-group-title');
    if (!title) return;
    var group = title.closest('.cro-filter-group');
    if (group) {
      group.classList.toggle('cro-filter--collapsed');
    }
  });

  /* -----------------------------------------------------------------------
     Mobile filter drawer
     ----------------------------------------------------------------------- */
  var filterToggle = document.querySelector('.cro-filter-toggle');
  var filterDrawer = document.getElementById('CroFilterDrawer');

  if (filterToggle && filterDrawer) {
    function openFilterDrawer() {
      filterDrawer.classList.add('cro-filter-drawer--open');
      filterToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      /* Focus the close button for accessibility */
      var closeBtn = filterDrawer.querySelector('.cro-filter-drawer-close');
      if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
    }

    function closeFilterDrawer() {
      filterDrawer.classList.remove('cro-filter-drawer--open');
      filterToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      filterToggle.focus();
    }

    filterToggle.addEventListener('click', openFilterDrawer);

    /* Close drawer */
    filterDrawer.addEventListener('click', function (e) {
      if (
        e.target.closest('.cro-filter-drawer-close') ||
        e.target.closest('.cro-filter-drawer-backdrop') ||
        e.target.closest('.cro-filter-drawer-apply')
      ) {
        closeFilterDrawer();
      }
    });

    /* Close drawer on Escape */
    filterDrawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeFilterDrawer();
      }
    });
  }

  /* -----------------------------------------------------------------------
     Sidebar search removed — now opens the global search overlay via
     data-cro-search-open attribute (handled in cro-search.js).
     ----------------------------------------------------------------------- */

  /* -----------------------------------------------------------------------
     Related sub-locations
     – State pages: fetch actual products from sub-locations via
       the Section Rendering API and show them in organized sections.
     – Non-state pages: show link chips to sibling locations.
     ----------------------------------------------------------------------- */
  var relatedEl = document.getElementById('CroRelatedLocations');
  if (relatedEl && window.CRO && window.CRO.locationIndex) {
    var locSlug = relatedEl.getAttribute('data-loc-slug');
    var locType = relatedEl.getAttribute('data-loc-type');
    var collectionHandle = relatedEl.getAttribute('data-collection') || 'all';

    if (locSlug) {
      /* Determine location type from the JS index (more reliable than
         current_tags since the URL may not include loc-type) */
      var _locEntry = null;
      var _idx = window.CRO.locationIndex;
      for (var _i = 0; _i < _idx.length; _i++) {
        if (_idx[_i].slug === locSlug) { _locEntry = _idx[_i]; break; }
      }
      var resolvedType = (_locEntry && _locEntry.type) || locType || '';

      if (resolvedType === 'state') {
        /* ---- STATE PAGE: load sub-location products ---- */
        renderStateSubLocations(relatedEl, locSlug, collectionHandle);
      } else {
        /* ---- NON-STATE PAGE: show link chips to siblings ---- */
        renderRelatedLinkChips(relatedEl, locSlug, collectionHandle);
      }
    }
  }

  /**
   * State pages — fetch collegiate + geo products grouped by sub-location
   * via the Section Rendering API.
   */
  function renderStateSubLocations(container, stateSlug, collectionHandle) {
    var index = window.CRO.locationIndex;

    /* Find the state's display name */
    var stateName = stateSlug;
    for (var i = 0; i < index.length; i++) {
      if (index[i].slug === stateSlug) { stateName = index[i].name; break; }
    }

    /* Verify this state has child locations before fetching */
    var hasChildren = false;
    for (var c = 0; c < index.length; c++) {
      if (index[c].parentStates && index[c].parentStates.indexOf(stateSlug) !== -1) {
        hasChildren = true; break;
      }
    }
    if (!hasChildren) return;

    /* Build loading skeleton */
    container.innerHTML =
      '<div class="cro-sublocations-loading">' +
        '<div class="cro-subloc-section">' +
          '<h2 class="cro-section-heading cro-section-heading--loading">Collegiate Designs</h2>' +
          '<div class="cro-subloc-skeleton"><div class="cro-skeleton-card"></div><div class="cro-skeleton-card"></div><div class="cro-skeleton-card"></div><div class="cro-skeleton-card"></div></div>' +
        '</div>' +
        '<div class="cro-subloc-section">' +
          '<h2 class="cro-section-heading cro-section-heading--loading">More ' + stateName + ' Designs</h2>' +
          '<div class="cro-subloc-skeleton"><div class="cro-skeleton-card"></div><div class="cro-skeleton-card"></div><div class="cro-skeleton-card"></div><div class="cro-skeleton-card"></div></div>' +
        '</div>' +
      '</div>';

    /* Fetch both sections in parallel */
    var sectionId = 'cro-sub-collection-grid';
    var baseUrl = '/collections/' + collectionHandle + '/parent-state:' + stateSlug;

    var collegiateUrl = baseUrl + '+category:collegiate?sections=' + sectionId;
    var geoUrl = baseUrl + '+category:geography?sections=' + sectionId;

    Promise.all([
      fetch(collegiateUrl).then(function (r) { return r.json(); }),
      fetch(geoUrl).then(function (r) { return r.json(); })
    ]).then(function (results) {
      var collegiateHtml = results[0][sectionId] || '';
      var geoHtml = results[1][sectionId] || '';

      var html = '';

      /* Section 2: Collegiate */
      if (collegiateHtml.trim()) {
        html += '<div class="cro-subloc-section">';
        html += '<h2 class="cro-section-heading">Collegiate Designs</h2>';
        html += collegiateHtml;
        html += '</div>';
      }

      /* Section 3: Other geo designs */
      if (geoHtml.trim()) {
        html += '<div class="cro-subloc-section">';
        html += '<h2 class="cro-section-heading">More ' + stateName + ' Designs</h2>';
        html += geoHtml;
        html += '</div>';
      }

      container.innerHTML = html || '';
    }).catch(function () {
      /* On error, fall back to link chips */
      renderRelatedLinkChips(container, stateSlug, collectionHandle);
    });
  }

  /**
   * Non-state pages — show link chips to sibling locations under the
   * parent state (e.g., "More in California" on the San Francisco page).
   */
  function renderRelatedLinkChips(container, locSlug, collectionHandle) {
    var index = window.CRO.locationIndex;

    /* Look up the current location entry */
    var currentLoc = null;
    for (var i = 0; i < index.length; i++) {
      if (index[i].slug === locSlug) { currentLoc = index[i]; break; }
    }

    var stateSlug = locSlug;
    var heading = 'Explore by Location';

    /* If this location has a parent, use its parent state */
    if (currentLoc && currentLoc.parentStates && currentLoc.parentStates.length > 0) {
      stateSlug = currentLoc.parentStates[0];
      for (var j = 0; j < index.length; j++) {
        if (index[j].slug === stateSlug) {
          heading = 'More in ' + index[j].name;
          break;
        }
      }
    }

    /* Find sibling locations */
    var children = index.filter(function (loc) {
      return loc.parentStates &&
             loc.parentStates.indexOf(stateSlug) !== -1 &&
             loc.slug !== locSlug;
    });

    if (children.length === 0) return;

    /* Group by type */
    var groups = {};
    children.forEach(function (loc) {
      var type = loc.type || 'other';
      if (!groups[type]) groups[type] = [];
      groups[type].push(loc);
    });

    Object.keys(groups).forEach(function (type) {
      groups[type].sort(function (a, b) { return a.name.localeCompare(b.name); });
    });

    var typeOrder = ['city', 'college', 'national-park', 'region', 'ski-resort', 'country', 'other'];
    var typeLabelsPlural = {
      'city': 'Cities', 'college': 'Colleges', 'national-park': 'National Parks',
      'region': 'Regions', 'ski-resort': 'Ski Resorts', 'country': 'Countries', 'other': 'Other'
    };

    var html = '<div class="cro-related-locations">';
    html += '<h3 class="cro-related-locations-heading">' + heading + '</h3>';

    typeOrder.forEach(function (type) {
      if (!groups[type]) return;
      var label = typeLabelsPlural[type] || type;
      html += '<div class="cro-related-group">';
      html += '<h4 class="cro-related-group-title">' + label + '</h4>';
      html += '<div class="cro-related-group-links">';
      groups[type].forEach(function (loc) {
        var href = '/collections/' + collectionHandle + '/loc-name:' + loc.slug;
        html += '<a href="' + href + '" class="cro-related-link">' + loc.name + '</a>';
      });
      html += '</div></div>';
    });

    html += '</div>';
    container.innerHTML = html;
  }

})();
